import Experience from "../Experience.js";
import Blokk from "./blokk.js";
import Rør from "./Rør.js";
import Animationer from "./animasjoner.js"
import Ui from "./ui.js";
import Himmel from "./Himmel.js"
import Skyer from "./Skyer.js"
import Rain from "./Rain.js";
export default class World{
    constructor(){
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.renderer = this.experience.renderer;
        
       
        this.resources.on('ready', () =>{
            this.blokk = new Blokk()
            this.rør = new Rør()
            this.animasjoner = new Animationer()
            // this.ui = new Ui()
            this.himmel = new Himmel()
            this.skyer = new Skyer()
            this.rain = new Rain()
        })
        this.resources.on("startDivTing", () => {
            console.log("You the man");
            
        });
        
    }   
    update(){
        {
            if(this.himmel)
                this.himmel.update()
        }
        {
            if(this.Skyer)
                this.Skyer.update()
        }
        {
            if(this.rain)
                this.rain.update()
        }
        {
            if(this.rør)
                this.rør.update()
        }
        // {
        //     if(this.ui)
        //         this.ui.update()
        // }
    }
}